export const  fixNumber = (num) => {
    num = parseFloat(num)
    if (num % 1 !== 0) {
        return parseFloat(num.toFixed(2));
      } else {
        return parseInt(num);
      }
  }
  